/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
import { defaultAppState } from './AppState';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { authReducer } from './auth/Auth.reducer';
var appReducers = combineReducers({
    authState: authReducer,
});
var makeDefaultLogoutState = function () {
    return {
        authState: defaultAppState.authState,
    };
};
export var rootReducer = function (state, action) {
    if (state === undefined) {
        state = defaultAppState;
    }
    if (!state.authState.token.length && !state.authState.isLoggedIn) {
        state = makeDefaultLogoutState();
    }
    return appReducers(state, action);
};
var persistConfig = {
    key: 'WVG',
    storage: storage,
    version: 1.0,
    whitelist: ['authState'],
};
export var appReducer = persistReducer(persistConfig, rootReducer);
